module.exports = __webpack_public_path__ + "img/quatrieme-couverture-carnets-esprit.0aae281d.png";